export const GET_EULA_VERSION = `
query GET_EULA_VERSION($body: AWSJSON) {
  getLatestFile(body: $body)
}
`